<template>
  <div class="card">
    <div class="card-content">
      <div class="field">
        <img class="is-pulled-right" src="../../assets/Loading/login.png" height=70% width=70%>
        <div class="is-clearfix"></div>
      </div>
      <div class="field">
        <label class="label">User ID</label>
        <div class="control">
          <input :class="'input is-success auto-input '+idbox" type="text" placeholder="Text input" :value="id">
        </div>
      </div>
      <div class="field">
        <label class="label">Password</label>
        <div class="control">
          <input :class="'input is-success auto-input '+pwbox" type="text" placeholder="Text input" :value="pw">
        </div>
      </div>
      <div class="field">
        <div class="buttons is-pulled-right">
          <button :class="'button is-light cancel '+cancelbtn">Cancel</button>
          <button id="login-btn" :class="'button is-light login '+loginbtn" v-on:click="loadSkip">Login(Skip)</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // アニメーションでIDとパスワードが打ち込まれるようなフォームのコンポーネント
  export default {
    name: "Form",
    data() {
      return {
        id: "|",
        pw: "",
        idbox: "",
        pwbox: "",
        loginbtn: "",
        cancelbtn: "",
        loadCanceled: false
      };
    },
    methods: {
      loadSkip() {
        this.$emit("loadCompleted");
      },
      cancelLoad() {
        this.loadCanceled = true;
        setTimeout(() => {
          this.id = "";
          this.pw = "toyKasket Presents";
          this.idbox = "enable-input";
        }, 500);
      }
    },
    mounted: function () {
      var idString = "toyKasket";
      var pwString = "Presents";
      // スクリプトで時間経過でthis.idとthis.pwの文字列を増やしていく
      (() => {
        // ID入力アニメーション
        return new Promise((resolve, reject) => {
          var count = 0;
          // IDフォームへフォーカス
          this.idbox = "input-focus";
          var intervalId = setInterval(() => {
            if (this.loadCanceled) {
              reject();
            }
            this.id = this.id.slice(0, -1);
            this.id = this.id + idString[count] + "|";
            count++;
            if (count >= idString.length) {
              clearInterval(intervalId);
              resolve();
            }
          }, 100);
        });
      })()
        .then(() => {
          // PW入力アニメーション
          return new Promise((resolve, reject) => {
            // ID入力後待つ
            setTimeout(() => {
              this.id = this.id.slice(0, -1);
              this.pw = "|";
              // フォーカス変更
              this.idbox = "";
              this.pwbox = "input-focus";
              var count = 0;
              var intervalId = setInterval(() => {
                if (this.loadCanceled) {
                  reject();
                }
                this.pw = this.pw.slice(0, -1);
                this.pw = this.pw + pwString[count] + "|";
                count++;
                if (count >= pwString.length) {
                  clearInterval(intervalId);
                  resolve();
                }
              }, 100);
            }, 100);
          });
        })
        .then(() => {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              if (this.loadCanceled) {
                reject();
              }
              // キャンセルボタンへフォーカス
              this.pwbox = "";
              this.pw = this.pw.slice(0, -1);
              this.cancelbtn = "hover";
              resolve();
            }, 200);
          });
        })
        .then(() => {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              if (this.loadCanceled) {
                reject();
              }
              //　ログインボタンへフォーカス
              this.cancelbtn = "";
              this.loginbtn = "hover";
              resolve();
            }, 400);
          });
        })
        .then(() => {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              if (this.loadCanceled) {
                reject();
              }
              //　ログインボタンをクリック
              this.loginbtn = "focus";
              resolve();
            }, 200);
          });
        })
        .then(() => {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              // ログインボタンロードアニメーションスタート
              this.loginbtn = "focus is-loading";
              resolve();
            }, 300);
          });
        })
        .then(() => {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              this.$emit("loadCompleted");
              resolve();
            }, 200);
          });
        });
    }
  };
</script>

<style lang="scss" scoped>
  @import url("https://fonts.googleapis.com/css?family=Play");

  .card {
    font-family: "Play", sans-serif;
    border-radius: 10px;
    background: #302823;
  }

  .card-content {
    padding-top: 30px;
    padding-bottom: 50px;
  }

  .label {
    color: #f8f3d9;
  }

  .buttons {
    pointer-events: none;
  }

  .input {
    pointer-events: none;
    border-color: transparent;
    background-color: #f8f3d9;
  }

  .enable-input {
    pointer-events: auto;
  }

  .input-focus {
    -webkit-box-shadow: 0 0 0 0.125em rgba(35, 209, 96, 0.25);
    box-shadow: 0 0 0 0.125em rgba(35, 209, 96, 0.25);
  }

  .cancel {
    background-color: #302823;
    color: #f8f3d9;
    &:hover,
    &.hover {
      background-color: #302823;
      color: #f8f3d9;
      border-color: #f8f3d9;
    }
    &:focus,
    &:active,
    &.focus {
      background-color: #302823;
      color: #f8f3d9;
      border-color: #302823;
    }
  }

  .login {
    pointer-events: auto;
    background-color: #98e3b4;
    color: #302823;
    font-weight: bold;
    animation-name: button-color;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    &:hover,
    &.hover {
      background-color: #f8f3d9;
      color: #302823;
      border-color: #f8f3d9;
    }
    &:focus,
    &:active,
    &.focus {
      background-color: #f8f3d9;
      color: #302823;
      border-color: #302823;
    }
  }

  @keyframes button-color {
    0% {
      background: #f8f3d9;
    }

    70% {
      background: #98e3b4;
    }

    100% {
      background: #f8f3d9;
    }
  }

  .button {
    font-family: "Play", sans-serif;
  }

  .input {
    font-family: "Play", sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/components/Loading/Form.vue